import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {ListaFaqComponent} from "./lista-faq/lista-faq.component";

const routes: Routes = [
  { path: "", component: ListaFaqComponent}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AjudaRoutingModule { }
